import { START_GET_LANGUAGES, START_GET_FILTERED_LANGUAGES } from '../types';
    
export const getLanguages = () => ({
    type: START_GET_LANGUAGES
})

export const getFilteredLanguages = () => ({
    type: START_GET_FILTERED_LANGUAGES
})